export const loadLazyScripts = () => {
  const scripts = document.querySelectorAll(
    'script[type="text/lazy-javascript"]'
  );

  scripts.forEach(script => {
    const newScript = script.cloneNode(true);
    newScript.type = 'text/javascript';
    script.parentNode.replaceChild(newScript, script);
  });
};
